module.exports = __webpack_public_path__ + "bda16e0592cb813e551180ae472ad066.jpg";